module.exports = __webpack_public_path__ + "static/scale-model-of-seattle-underground-in-seattle-washington-1ff2b1960f4aa3556fa143f23c35dca3.png";